import {
  urlLogin,
  urlCambiarContrasenia,
  urlRecuperarContrasenia,
  urlVerificarToken,
  urlConsultarPlaca,
  urlConsultarCedula,
  urlListarAccesorios,
  urlListarTerritorios,
  urlListarModelos,
  urlObtenerDatosCliente,
  urlListarEstadosCiviles,
  urlListarGeneros,
  urlListarProvincias,
  urlListarCiudades,
  urlGuardarDatosFacturacion,
  urlGenerarCotizacion,
  urlListarColores,
  urlListarCoberturas,
  urlListarAmparosAdicionales,
  urlGuardarLead,
  urlObtenerAyuda,
  urlPorcentajeExtras,
  urlObtenerMensaje,
  urlRestriccionModelo,
  urlValidarComprasPendientes,
  urlPlaceToPay,
  urlDashboard,
  urlDeduciblesRoles,
  urlCoberturasAccidente,
  urlPersoneria,
  urlConsultarIdentificacion,
  urlCalcularCotizacionAP,
  urlObtenerFormasPago,
  urlObtenerDatosDebitoAutomatico,
  urlObtenerConductos,
  urlGuardarConducto,
  urlGuardarFormasPago,
  urlListarRelatividades,
  urlRecuperarDatosFacturacionC,
  urlGuardarDatosFacturacionC,
  urlPlaceToPayCotizacion,
  urlListarCotizadoresPermisos,
  ambienteAplicacion,
  urlGenerarCotizacionAbierto,
  urlGenerarCotizacionAuto,
  urlListarProvinciasComparador,
  urlDeduciblesRolesComparador,
  urlListarParentescos,
  urlGuardarDatosFacturacionRenovacion,
  urlSubirSftpRenovaciones,
  urlGenerarCotizacionAutoRenovacion,
  urlObtenerFormasPagoRenovaciones,
  urlGuardarFormasPagoRenovaciones,
  urlCatalogoTipoCombustible,
  urlTipoCombustiblePorMarcaModelo,
} from "../../constants/urls";
import { createAction } from "redux-actions";
import { desencriptarTramaAES } from "../../utils/Encriptar";
import { datosSolicitarContrasenia } from "../reducers/rlogin";

import { httpClient } from "../../api/httpClient";
import axios from "axios";
import { infoIds } from "../../constants";
import { generarParametrosUrl, getFirstNumber } from "../../utils/validaciones";
export const CONSULTAR_PLACA_HAS_ERRORED = "CONSULTAR_PLACA_HAS_ERRORED";
export const CONSULTAR_PLACA_IS_LOADING = "CONSULTAR_PLACA_IS_LOADING";

export const OBTENER_DATOS_CLIENTE_HAS_ERRORED =
  "OBTENER_DATOS_CLIENTE_HAS_ERRORED";
export const OBTENER_DATOS_CLIENTE_IS_LOADING =
  "OBTENER_DATOS_CLIENTE_IS_LOADING";

export const OBTENER_DATOS_HAS_ERRORED = "OBTENER_DATOS_HAS_ERRORED";
export const OBTENER_DATOS_IS_LOADING = "OBTENER_DATOS_IS_LOADING";

export const CONSULTAR_CEDULA_HAS_ERRORED = "CONSULTAR_CEDULA_HAS_ERRORED";
export const CONSULTAR_CEDULA_ASEGURADO_HAS_ERRORED = "CONSULTAR_CEDULA_ASEGURADO_HAS_ERRORED";
export const CONSULTAR_CEDULA_CONTRATANTE_HAS_ERRORED = "CONSULTAR_CEDULA_CONTRATANTE_HAS_ERRORED";
export const CONSULTAR_CEDULA_IS_LOADING = "CONSULTAR_CEDULA_IS_LOADING";

export const CONSULTAR_COBERTURAS_HAS_ERRORED =
  "CONSULTAR_COBERTURAS_HAS_ERRORED";
export const CONSULTAR_COBERTURAS_IS_LOADING =
  "CONSULTAR_COBERTURAS_IS_LOADING";

export const TIENE_POLIZA_PLACA = "TIENE_POLIZA_PLACA";

export const MENSAJE_ERROR_POLIZA_PLACA = "MENSAJE_ERROR_POLIZA_PLACA";

export const AMPAROS_ADICIONALES_HAS_ERRORED =
  "AMPAROS_ADICIONALES_HAS_ERRORED";
export const AMPAROS_ADICIONALES_IS_LOADING = "AMPAROS_ADICIONALES_IS_LOADING";
export const SET_AMPAROS_ADICIONALES = "SET_AMPAROS_ADICIONALES";

export const GUARDAR_LEAD_HAS_ERRORED = "GUARDAR_LEAD_HAS_ERRORED";
export const GUARDAR_LEAD_IS_LOADING = "GUARDAR_LEAD_IS_LOADING";

export const OBTENER_AYUDA_HAS_ERRORED = "OBTENER_AYUDA_HAS_ERRORED";
export const OBTENER_AYUDA_IS_LOADING = "OBTENER_AYUDA_IS_LOADING";
export const LIMPIAR_AYUDA = "LIMPIAR_AYUDA";
export const SET_AYUDA = "SET_AYUDA";

export const LIMPIAR_PORCENTAJE_EXTRAS = "LIMPIAR_PORCENTAJE_EXTRAS";
export const PORCENTAJE_EXTRAS_LOADING = "PORCENTAJE_EXTRAS_LOADING";
export const PORCENTAJE_EXTRAS_HAS_ERRORED = "PORCENTAJE_EXTRAS_HAS_ERRORED";
export const SET_PORCENTAJE_EXTRAS = "SET_PORCENTAJE_EXTRAS";

export const CONSULTAR_PLACA = "CONSULTAR_PLACA";
export const SET_DATOS_PERSONA = "SET_DATOS_PERSONA";
export const SET_DATOS_PERSONA_ASEGURADO = "SET_DATOS_PERSONA_ASEGURADO";
export const SET_DATOS_PERSONA_CONTRATANTE = "SET_DATOS_PERSONA_CONTRATANTE";
export const SET_DATOS_PAGADOR = "SET_DATOS_PAGADOR";
export const SET_DATOS_FACTURACION = "SET_DATOS_FACTURACION";
export const SET_ACCESORIOS = "SET_ACCESORIOS";
export const SET_COLORES = "SET_COLORES";
export const SET_TIPO_COMBUSTIBLE = "SET_TIPO_COMBUSTIBLE";
export const SET_TERRITORIOS = "SET_TERRITORIOS";
export const SET_TERRITORIO_DEFAULT = "SET_TERRITORIO_DEFAULT";
export const SET_MODELOS = "SET_MODELOS";
export const SET_ESTADOS_CIVILES = "SET_ESTADOS_CIVILES";
export const SET_PARENTESCOS = "SET_PARENTESCOS";
export const SET_GENEROS = "SET_GENEROS";
export const SET_PROVINCIAS = "SET_PROVINCIAS";
export const SET_PROVINCIAS2 = "SET_PROVINCIAS2";
export const SET_CIUDADES = "SET_CIUDADES";
export const SET_CIUDADES2 = "SET_CIUDADES2";
export const SET_DATOS_PAGO = "SET_DATOS_PAGO";
export const SET_DATOS_DESCARGA = "SET_DATOS_DESCARGA";
export const SET_COBERTURAS = "SET_COBERTURAS";

export const LIMPIAR_DATOS_COTIZACION = "LIMPIAR_DATOS_COTIZACION";
export const LIMPIAR_DATOS_COTIZACION2 = "LIMPIAR_DATOS_COTIZACION2";
export const LIMPIAR_CATALOGOS = "LIMPIAR_CATALOGOS";
export const LIMPIAR_DATOS_DESCARGA = "LIMPIAR_DATOS_DESCARGA";
export const LIMPIAR_DATOS_ENVIO = "LIMPIAR_DATOS_ENVIO";

export const LISTAR_ACCESORIOS_HAS_ERRROR = "LISTAR_ACCESORIOS_HAS_ERRROR";
export const LISTAR_ACCESORIOS_IS_LOADING = "LISTAR_ACCESORIOS_IS_LOADING";

export const LISTAR_TERRITORIOS_HAS_ERRROR = "LISTAR_TERRITORIOS_HAS_ERRROR";
export const LISTAR_TERRITORIOS_IS_LOADING = "LISTAR_TERRITORIOS_IS_LOADING";

export const LISTAR_MODELOS_HAS_ERRROR = "LISTAR_MODELOS_HAS_ERROR";
export const LISTAR_MODELOS_IS_LOADING = "LISTAR_MODELOS_IS_LOADING";

export const LISTAR_ESTADOS_CIVILES_HAS_ERROR =
  "LISTAR_ESTADOS_CIVILES_HAS_ERRROR";
export const LISTAR_ESTADOS_CIVILES_IS_LOADING =
  "LISTAR_ESTADOS_CIVILES_IS_LOADING";

export const LISTAR_GENEROS_HAS_ERROR = "LISTAR_GENEROS_HAS_ERROR";
export const LISTAR_GENEROS_IS_LOADING = "LISTAR_GENEROS_IS_LOADING";

export const LISTAR_PROVINCIAS_HAS_ERROR = "LISTAR_GENEROS_HAS_ERROR";
export const LISTAR_PROVINCIAS_IS_LOADING = "LISTAR_GENEROS_IS_LOADING";

export const LISTAR_CIUDADES_HAS_ERROR = "LISTAR_CIUDADES_HAS_ERROR";
export const LISTAR_CIUDADES_IS_LOADING = "LISTAR_CIUDADES_IS_LOADING";

export const GUARDAR_DATOS_HAS_ERROR = "GUARDAR_DATOS_HAS_ERROR";
export const GUARDAR_DATOS_IS_LOADING = "GUARDAR_DATOS_IS_LOADING";

export const GENERAR_COTIZACION_HAS_ERROR = "GENERAR_COTIZACION_HAS_ERROR";
export const GENERAR_COTIZACION_IS_LOADING = "GENERAR_COTIZACION_IS_LOADING";
export const DESCARGA_OK = "DESCARGA_OK";
export const ENVIO_OK = "ENVIO_OK";
export const CORREO_ENVIAR = "CORREO_ENVIAR";
export const ENVIAR_COTIZACION_HAS_ERROR = "ENVIAR_COTIZACION_HAS_ERROR";
export const ENVIAR_COTIZACION_IS_LOADING = "ENVIAR_COTIZACION_IS_LOADING";

export const LISTAR_COLORES_HAS_ERRROR = "LISTAR_COLORES_HAS_ERRROR";
export const LISTAR_COLORES_IS_LOADING = "LISTAR_COLORES_IS_LOADING";
export const LISTAR_TIPO_COMBUSTIBLE_HAS_ERROR = "LISTAR_TIPO_COMBUSTIBLE_HAS_ERROR";
export const LISTAR_TIPO_COMBUSTIBLE_IS_LOADING = "LISTAR_TIPO_COMBUSTIBLE_IS_LOADING";

export const OBTENER_MSG_HAS_ERRORED = "OBTENER_MSG_HAS_ERRORED";
export const OBTENER_MSG_IS_LOADING = "OBTENER_MSG_IS_LOADING";
export const SET_MSG = "SET_MSG";

export const OBTENER_VALIDAR_MODELO_HAS_ERRORED =
  "OBTENER_VALIDAR_MODELO_HAS_ERRORED";
export const OBTENER_VALIDAR_MODELO_IS_LOADING =
  "OBTENER_VALIDAR_MODELO_IS_LOADING";
export const SET_VALIDAR_MODELO = "SET_VALIDAR_MODELO";

export const VALIDAR_PAGO_PENDIENTE_HAS_ERRORED =
  "VALIDAR_PAGO_PENDIENTE_HAS_ERRORED";
export const VALIDAR_PAGO_PENDIENTE_IS_LOADING =
  "VALIDAR_PAGO_PENDIENTE_IS_LOADING";

export const OBTENER_URL_PAGO_HAS_ERRORED = "OBTENER_URL_PAGO_HAS_ERRORED";
export const OBTENER_URL_PAGO_IS_LOADING = "OBTENER_URL_PAGO_IS_LOADING";
export const LIMPIAR_URL_PAGO = "LIMPIAR_URL_PAGO";
export const MSG_URL_PAGO = "MSG_URL_PAGO";

export const LIMPIAR_DASHBOARD = "LIMPIAR_DASHBOARD";
export const DASHBOARD_LOADING = "DASHBOARD_LOADING";
export const DASHBOARD_ERRORED = "DASHBOARD_ERRORED";
export const SET_DASHBOARD = "SET_DASHBOARD";

export const SET_PERSONERIA_TIPO_IDENTI = "SET_PERSONERIA_TIPO_IDENTI";

//Consultar Identificacion - Cotizacion Accidentes Personales
export const CONSULTAR_IDENTIFICACION_AP_HAS_ERRORED =
  "CONSULTAR_IDENTIFICACION_AP_HAS_ERRORED";
export const CONSULTAR_IDENTIFICACION_AP_IS_LOADING =
  "CONSULTAR_IDENTIFICACION_AP_IS_LOADING";
export const SET_CONSULTAR_IDENTIFICACION_AP =
  "SET_CONSULTAR_IDENTIFICACION_AP";

export const SET_DATA_TERRITORIOS_COMPARADOR = "SET_DATA_TERRITORIOS_COMPARADOR";

export const setDataTerritoriosComparador = createAction("SET_DATA_TERRITORIOS_COMPARADOR");

const consultarIdentificacionAPhasError = () => ({
  type: CONSULTAR_IDENTIFICACION_AP_HAS_ERRORED,
});
const consultarIdentificacionAPIsLoading = () => ({
  type: CONSULTAR_IDENTIFICACION_AP_IS_LOADING,
});
export const setConsultarIdentificacionsAP = (payload) => ({
  type: SET_CONSULTAR_IDENTIFICACION_AP,
  payload,
});

export const TerritoriosComparador = valor => ({
  type: SET_DATA_TERRITORIOS_COMPARADOR,
  territorios: valor
});



export const setPersoneria = createAction("SET_PERSONERIA_TIPO_IDENTI");


// Para listar los limites de ingreso de valores en la serire del chasis y el motor
export const setLimitesChasis = createAction("SET_LIMITES_CHASIS");
export const setLimitesAmparo = createAction("SET_LIMITES_Amparo");
export const setLimitesAvaluo = createAction("SET_LIMITES_AVALUO");
export const setLimitesMotor = createAction("SET_LIMITES_MOTOR");
export const limitesError = createAction("LIMITES_ERROR");


//Para consumir Roles y deducibles mediate redux-actions
export const deduciblesRolesisLoading = createAction(
  "OBTENER_DEDUCIBLES_ROLES_IS_LOADING"
);
export const deduciblesRoleshasError = createAction(
  "OBTENER_DEDUCIBLES_ROLES_HAS_ERROR"
);
export const deduciblesRoles = createAction("SET_OBTENER_DEDUCIBLES_ROLES");


const obtenerUrlPagoError = () => ({ type: OBTENER_URL_PAGO_HAS_ERRORED });
const obtenerUrlPagoIsLoading = () => ({ type: OBTENER_URL_PAGO_IS_LOADING });
const limpiarUrlPago = () => ({ type: LIMPIAR_URL_PAGO });
const msgUrlPago = () => ({ type: MSG_URL_PAGO });

const validarPagoPendienteError = () => ({
  type: VALIDAR_PAGO_PENDIENTE_HAS_ERRORED,
});
const validarPagoPendienteIsLoading = () => ({
  type: VALIDAR_PAGO_PENDIENTE_IS_LOADING,
});

const validarModeloError = () => ({ type: OBTENER_VALIDAR_MODELO_HAS_ERRORED });
const validarModeloIsLoading = () => ({
  type: OBTENER_VALIDAR_MODELO_IS_LOADING,
});

export const setValidarModelo = createAction(SET_VALIDAR_MODELO);
export const setMsg = createAction(SET_MSG);

const obtenerMsgError = () => ({ type: OBTENER_MSG_HAS_ERRORED });
const obtenerMsgIsLoading = () => ({ type: OBTENER_MSG_IS_LOADING });

const consultarPlacaError = () => ({ type: CONSULTAR_PLACA_HAS_ERRORED });
const consultarPlacaIsLoading = () => ({ type: CONSULTAR_PLACA_IS_LOADING });
const tienePolizaPlaca = () => ({ type: TIENE_POLIZA_PLACA });
const mensajeErrorPolizaPlaca = () => ({ type: MENSAJE_ERROR_POLIZA_PLACA });
const listarAccesoriosError = () => ({ type: LISTAR_ACCESORIOS_HAS_ERRROR });
const listarAccesoriosIsLoading = () => ({
  type: LISTAR_ACCESORIOS_IS_LOADING,
});
const listarColoresError = () => ({ type: LISTAR_COLORES_HAS_ERRROR });
const listarColoresIsLoading = () => ({ type: LISTAR_COLORES_IS_LOADING });
const listarTipoCombustibleError = () => ({ type: LISTAR_TIPO_COMBUSTIBLE_HAS_ERROR });
const listarTipoCombustibleIsLoading = () => ({ type: LISTAR_TIPO_COMBUSTIBLE_IS_LOADING });

const obtenerDatosClienteError = () => ({
  type: OBTENER_DATOS_CLIENTE_HAS_ERRORED,
});
const obtenerDatosClienteIsLoading = () => ({
  type: OBTENER_DATOS_CLIENTE_IS_LOADING,
});

const listarTerritoriosError = () => ({ type: LISTAR_TERRITORIOS_HAS_ERRROR });
const listarTerritoriosIsLoading = () => ({
  type: LISTAR_TERRITORIOS_IS_LOADING,
});

const listarModelosError = () => ({ type: LISTAR_MODELOS_HAS_ERRROR });
const listarModelosIsLoading = () => ({ type: LISTAR_MODELOS_IS_LOADING });
const consultarCedulaError = () => ({ type: CONSULTAR_CEDULA_HAS_ERRORED });
const consultarCedulaAseguradoError = () => ({ type: CONSULTAR_CEDULA_ASEGURADO_HAS_ERRORED });
const consultarCedulaContratanteError = () => ({ type: CONSULTAR_CEDULA_CONTRATANTE_HAS_ERRORED });
const consultarCedulaIsLoading = () => ({ type: CONSULTAR_CEDULA_IS_LOADING });
const listarECivilesHasError = () => ({
  type: LISTAR_ESTADOS_CIVILES_HAS_ERROR,
});
const listarECivilesIsLoading = () => ({
  type: LISTAR_ESTADOS_CIVILES_IS_LOADING,
});

const listarGenerosHasError = () => ({ type: LISTAR_GENEROS_HAS_ERROR });
const listarGenerosIsLoading = () => ({ type: LISTAR_GENEROS_IS_LOADING });

const listarProvinciasHasError = () => ({ type: LISTAR_PROVINCIAS_HAS_ERROR });
const listarProvinciasIsLoading = () => ({
  type: LISTAR_PROVINCIAS_IS_LOADING,
});

const listarCiudadesHasError = () => ({ type: LISTAR_CIUDADES_HAS_ERROR });
const listarCiudadesIsLoading = () => ({ type: LISTAR_CIUDADES_IS_LOADING });
const guardarDatosHasError = () => ({ type: GUARDAR_DATOS_HAS_ERROR });
const guardarDatosIsLoading = () => ({ type: GUARDAR_DATOS_IS_LOADING });

const generarCotizacionHasError = () => ({
  type: GENERAR_COTIZACION_HAS_ERROR,
});
const generarCotizacionIsLoading = () => ({
  type: GENERAR_COTIZACION_IS_LOADING,
});
const enviarCotizacionHasError = () => ({ type: ENVIAR_COTIZACION_HAS_ERROR });
const enviarCotizacionIsLoading = () => ({
  type: ENVIAR_COTIZACION_IS_LOADING,
});

export const setConsultaPlaca = (payload) => ({
  type: CONSULTAR_PLACA,
  payload,
});

export const setMensajeError = (payload) => ({
  type: MENSAJE_ERROR_POLIZA_PLACA,
  payload,
});


export const limpiarDatosCotizacion = () => ({
  type: LIMPIAR_DATOS_COTIZACION,
});
export const limpiarDatosDescarga = () => ({ type: LIMPIAR_DATOS_DESCARGA });
export const limpiarDatosEnvio = () => ({ type: LIMPIAR_DATOS_ENVIO });
export const limpiarCatalogos = () => ({ type: LIMPIAR_CATALOGOS });
export const limpiarDatosCotizacion2 = () => ({
  type: LIMPIAR_DATOS_COTIZACION2,
});

export const setDatosPersona = createAction(SET_DATOS_PERSONA);
export const setDatosPersonaAsegurado = createAction(SET_DATOS_PERSONA_ASEGURADO);
export const setDatosPersonaContratante = createAction(SET_DATOS_PERSONA_CONTRATANTE);
export const setAccesorios = createAction(SET_ACCESORIOS);
export const setColores = createAction(SET_COLORES);
export const setTipoCombustible = createAction(SET_TIPO_COMBUSTIBLE);
export const setCorreo = createAction(CORREO_ENVIAR);



//FACTURACION --------------
//Recuperar datos
export const recuperarDatosFacturacionIsLoading = createAction(
  "RECUPERAR_DATOS_FACTURACION_IS_LOADING"
);
export const recuperarDatosFacturacionhasError = createAction(
  "RECUPERAR_DATOS_FACTURACION_HAS_ERROR"
);
export const setRecuperarDatosFacturacion = createAction(
  "SET_RECUPERAR_DATOS_FACTURACION"
);

//Guardar datos - mediate redux-actions
export const guardarDatosFacturacionIsLoading = createAction(
  "GUARDAR_DATOS_FACTURACION_IS_LOADING"
);
export const guardarDatosFacturacionhasError = createAction(
  "GUARDAR_DATOS_FACTURACION_HAS_ERROR"
);
export const setDatosFacturacionC = createAction("SET_DATOS_FACTURACIONC");

//FIN FACTURACION ---------

//COTIZACION HOGAR -----------------------
export const setProvinciasHogar = createAction("SET_PROVINCIAS_HOGAR");
export const listarProvinciasHogarError = createAction(
  "LISTAR_PROVINCIAS_HOGAR_ERROR"
);
export const listarProvinciasHogarloading = createAction(
  "LISTAR_PROVINCIAS_HOGAR_LOADING"
);

export const setRelatividadesHogar = createAction("SET_RELATIVIDADES_HOGAR");
export const listarRelatividadesHogarError = createAction(
  "LISTAR_RELATIVIDADES_HOGAR_ERROR"
);
export const listarRelatividadesHogarloading = createAction(
  "LISTAR_RELATIVIDADES_HOGAR_LOADING"
);

//FIN COTIZACION HOGAR -------------------

export function setProvincias2(payload) {
  return {
    type: SET_PROVINCIAS2,
    payload,
  };
}

export function setCiudades2(payload) {
  return {
    type: SET_CIUDADES2,
    payload,
  };
}

export const setTerritorios = createAction(SET_TERRITORIOS);
export const setTerritoriosDefault = createAction(SET_TERRITORIO_DEFAULT);
export const setModelos = createAction(SET_MODELOS);
export const setDatosPagador = createAction(SET_DATOS_PAGADOR);

export const setDatosFacturacion = createAction(SET_DATOS_FACTURACION);
export const setEstadosCiviles = createAction(SET_ESTADOS_CIVILES);
export const setParentescos = createAction(SET_PARENTESCOS);
export const setGeneros = createAction(SET_GENEROS);
export const setProvincias = createAction(SET_PROVINCIAS);
export const setCiudades = createAction(SET_CIUDADES);

export const setDatosPago = createAction(SET_DATOS_PAGO);
export const setDatosDescarga = createAction(SET_DATOS_DESCARGA);
export const setDescargaOK = createAction(DESCARGA_OK);
export const setEnvioOK = createAction(ENVIO_OK);

export const setDataCoberturas = createAction(SET_COBERTURAS);
export const setDataAmparosAdicionales = createAction(SET_AMPAROS_ADICIONALES);

export const coberturasError = (bool) => ({
  type: CONSULTAR_COBERTURAS_HAS_ERRORED,
  coberturasError: bool,
});

const coberturasisLoading = () => ({ type: CONSULTAR_COBERTURAS_IS_LOADING });
//------

const amparosAdicionalesHasError = () => ({
  type: AMPAROS_ADICIONALES_HAS_ERRORED,
});
const amparosAdicionalesisLoading = () => ({
  type: AMPAROS_ADICIONALES_IS_LOADING,
});
const guardarLeadHasError = () => ({ type: GUARDAR_LEAD_HAS_ERRORED });
const guardarLeadisLoading = () => ({ type: GUARDAR_LEAD_IS_LOADING });

//--- Ayudas
const obtenerAyudaError = () => ({ type: OBTENER_AYUDA_HAS_ERRORED });
const obtenerAyudaIsLoading = () => ({ type: OBTENER_AYUDA_IS_LOADING });

export const limpiarAyuda = () => ({ type: LIMPIAR_AYUDA });
export const setAyuda = createAction(SET_AYUDA);

//VALIDACION EXTRAS POR ZONA------
export const limpiarPorcentajeExtras = () => ({
  type: LIMPIAR_PORCENTAJE_EXTRAS,
});
export const porcentajeExtrasIsLoading = () => ({
  type: PORCENTAJE_EXTRAS_LOADING,
});
export const porcentajeExtrasHasErrored = () => ({
  type: PORCENTAJE_EXTRAS_HAS_ERRORED,
});
export const setPorcentajeExtras = createAction(SET_PORCENTAJE_EXTRAS);

//Cargar Datos Dashboard
export const limpiarDashboard = () => ({ type: LIMPIAR_DASHBOARD });
export const dashboardLoading = () => ({ type: DASHBOARD_LOADING });
export const dashboardErrored = () => ({ type: DASHBOARD_ERRORED });
export const setDashboard = createAction(SET_DASHBOARD);

//--Formas de pago adicionales -----------------------------------------------------------
export const OBTENER_FORMAS_PAGO_HAS_ERRORED =
  "OBTENER_FORMAS_PAGO_HAS_ERRORED";
export const OBTENER_FORMAS_PAGO_IS_LOADING = "OBTENER_FORMAS_PAGO_IS_LOADING";
export const SET_OBTENER_FORMAS_PAGO = "SET_OBTENER_FORMAS_PAGO";
export const OBTENER_DATOS_DEBITO_HAS_ERRORED =
  "OBTENER_DATOS_DEBITO_HAS_ERRORED";
export const OBTENER_DATOS_DEBITO_IS_LOADING =
  "OBTENER_DATOS_DEBITO_IS_LOADING";
export const SET_OBTENER_DATOS_DEBITO = "SET_OBTENER_DATOS_DEBITO";
export const OBTENER_CONDUCTOS_HAS_ERRORED = "OBTENER_CONDUCTOS_HAS_ERRORED";
export const OBTENER_CONDUCTOS_IS_LOADING = "OBTENER_CONDUCTOS_IS_LOADING";
export const SET_OBTENER_CONDUCTOS = "SET_OBTENER_CONDUCTOS";
export const GUARDAR_CONDUCTO_HAS_ERRORED = "GUARDAR_CONDUCTO_HAS_ERRORED";
export const GUARDAR_CONDUCTO_IS_LOADING = "GUARDAR_CONDUCTO_IS_LOADING";
export const SET_GUARDAR_CONDUCTO = "SET_GUARDAR_CONDUCTO";
export const GUARDAR_FORMA_PAGO_HAS_ERRORED = "GUARDAR_FORMA_PAGO_HAS_ERRORED";
export const GUARDAR_FORMA_PAGO_IS_LOADING = "GUARDAR_FORMA_PAGO_IS_LOADING";
export const SET_GUARDAR_FORMA_PAGO = "SET_GUARDAR_FORMA_PAGO";
export function setObtenerFormasPago(payload) {
  return {
    type: SET_OBTENER_FORMAS_PAGO,
    payload,
  };
}
export const setDatosAdicionales = createAction(
  "SET_DATOS_ADICIONALES"
);

const obtenerFormasPagoHasError = () => ({
  type: OBTENER_FORMAS_PAGO_HAS_ERRORED,
});
const obtenerFormasPagoIsLoading = () => ({
  type: OBTENER_FORMAS_PAGO_IS_LOADING,
});
export function setObtenerDatosDebitoAutomatico(payload) {
  return {
    type: SET_OBTENER_DATOS_DEBITO,
    payload,
  };
}
const obtenerDatosDebitoAutomaticoHasError = () => ({
  type: OBTENER_DATOS_DEBITO_HAS_ERRORED,
});
const obtenerDatosDebitoAutomaticoIsLoading = () => ({
  type: OBTENER_DATOS_DEBITO_IS_LOADING,
});
export function setObtenerConductos(payload) {
  return {
    type: SET_OBTENER_CONDUCTOS,
    payload,
  };
}
const obtenerConductosHasError = () => ({
  type: OBTENER_CONDUCTOS_HAS_ERRORED,
});
const obtenerConductosIsLoading = () => ({
  type: OBTENER_CONDUCTOS_IS_LOADING,
});
export function setGuardarConducto(payload) {
  return {
    type: SET_GUARDAR_CONDUCTO,
    payload,
  };
}
const guardarConductoHasError = () => ({
  type: GUARDAR_CONDUCTO_HAS_ERRORED,
});
const guardarConductoIsLoading = () => ({
  type: GUARDAR_CONDUCTO_IS_LOADING,
});
export function setGuardarFormaPago(payload) {
  return {
    type: SET_GUARDAR_FORMA_PAGO,
    payload,
  };
}
const guardarFormaPagoHasError = (payload) => ({
  type: GUARDAR_FORMA_PAGO_HAS_ERRORED,
  payload
});
const guardarFormaPagoIsLoading = () => ({
  type: GUARDAR_FORMA_PAGO_IS_LOADING,
});
//Fin FOrmas de pago adicionales-------------------------------------

export const ObtenerAyudaFetch = (codigo, seccion) => async (dispatch) => {
  var url = `${urlObtenerAyuda}&codigoAyuda=${codigo}&seccionAyuda=${seccion}`;
  dispatch(obtenerAyudaIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion === true) {
        dispatch(limpiarAyuda());
        dispatch(setAyuda(data));
      } else {
        dispatch(obtenerAyudaError());
      }
    })
    .catch((response) => {
      dispatch(obtenerAyudaError());
    });
};

export const GuardarLeadFetch = (param) => async (dispatch) => {
  var url = `${urlGuardarLead}`;
  dispatch(guardarLeadisLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion === false) {
        dispatch(guardarLeadHasError());
      }
    })
    .catch((response) => {
      dispatch(guardarLeadHasError());
    });
};

export const AmparosAdicionalesFetch = (territorio, codEspecial) => async (dispatch) => {
  dispatch(amparosAdicionalesisLoading());

  await fetch(urlListarAmparosAdicionales + territorio + '&codigoProductoEspecial=' + codEspecial)
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        var coberturas = [];
        coberturas = data.coberturas;

        dispatch(setDataAmparosAdicionales(coberturas));
      } else {
        dispatch(amparosAdicionalesHasError());
      }
    })
    .catch(() => {
      dispatch(amparosAdicionalesHasError());
    });
};

export const coberturasFetch = (territorio) => async (dispatch) => {
  dispatch(coberturasisLoading());
  await fetch(urlListarCoberturas + territorio)
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        var coberturas = [];
        coberturas = data.coberturas;

        dispatch(setDataCoberturas(coberturas));
      } else {
        dispatch(coberturasError(""));
      }
    })
    .catch(() => {
      dispatch(coberturasError(""));
    });
};

let cargarDatosAdicionales = (dataConsulta, datosPersona) => {
  console.log("dataConsulta", dataConsulta);
  console.log("datosPersona", datosPersona);

  /*const url = urlPlaceToPayCotizacion;
  axios
    .get(url, {
      "content-type": "application/json",
      Accept: "application/json",
      params: {
        idCarrito: this.state.idCarrito,
        placa: "PBC0093",
        identificacionConductor: "1802315596",
        empresa: "AIGMETROPOLITANA",
        tipoProducto: "",
        sumaAsegurada: "15000",
      },
    })
    .then((response) => {
      let data = response.data;
      console.log("data", data);
     
    })
    .catch((error) => {
      console.log(error);
    });*/
  let extra = {
    avaluo: "18000",
  };

  if (extra.avaluo.length > 0) {
    dataConsulta.valor_avaluo = extra.avaluo;
    dataConsulta.valorAsegurado = extra.avaluo;
    dataConsulta.mostrarAvaluo = false;
  }
  if (datosPersona.validacionesEdad) {
    dataConsulta.mostrarPropietario = false;
  }
  return dataConsulta;
};

export const guardarDatosAsegurado = (datos) => {
  return async (dispatch) => {
    console.log('datosVer', datos)
    dispatch(setDatosPersonaAsegurado(datos));
  }


}

export const guardarDatosContratante = (datos) => {
  return async (dispatch) => {
    console.log('datosVer', datos)
    dispatch(setDatosPersonaContratante(datos));
  }


}

export const FetchGuardarDatosFacturacionRenovacion = (param) => async (dispatch) => {
  var url = `${urlGuardarDatosFacturacionRenovacion}`;
  dispatch(guardarDatosIsLoading());
  await httpClient.post(url, param)
    .then(async (data) => {
      console.log('dataPagador', data, param)
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        const urlPago = data.urlpago;
        const codigoPago = data.traCodigoPago;
        const pagopendiente = data.pagoPendiente;
        const referencia = data.referencia;
        const datosPago = {
          url: urlPago,
          codigoPago: codigoPago,
          pagopendiente: pagopendiente,
          referencia: referencia,
        };

        // let subir = await subirSftp(data.polResponse.id)


        dispatch(setDatosPago(datosPago));
      } else {
        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosPago(data));
        dispatch(guardarDatosHasError());
      }
    })
    .catch((response) => {
      console.error(response);
      dispatch(guardarDatosHasError());
      dispatch(setDatosPago({}));
      //dispatch(ProductosCarrito(response));
    });
};

export const subirSftp = async (carrito) => {

  //return {transaccion: true}
  try {


    const url = `${urlSubirSftpRenovaciones}&empresa=AIGMETROPOLITANA&idCarrito=${carrito}`;
    const data = await httpClient.get(url);

    return data;
  } catch (error) {
    console.error('Error en validarSiniestralidad:', error);
    return {
      transaccion: false,
      mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
    };
  }
}


export const obtenerDatosClienteFetchRenovacion = (idCliente) => async (dispatch) => {


  //console.log(`cambiar url ${urlObtenerDatosCliente}${idCliente}`);
  dispatch(obtenerDatosClienteIsLoading());
  await fetch(`${urlObtenerDatosCliente}${idCliente}`)
    .then((response) => response.json())
    .then((data) => {

      console.log('datosSolicitarContrasenia', datosSolicitarContrasenia.cliEmail, data.datosCliente.cliEmail);
      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let datos = data.datosCliente;
        const datosCliente = {
          cliNombres: datos.cliIdentificacion.length == '13' ? datos.cliRazonSocial : datos.cliNombre1 + " " + datos.cliNombre2,
          cliApellidos: datos.cliApellido1 + " " + datos.cliApellido2,
          cliCelular: datos.cliCelular,
          // cliEmail: datosSolicitarContrasenia.cliEmail,
          cliEmail: datos.cliEmail,
          cliTelefono: datos.cliTelefono,
          cliDireccion: datos.cliDireccion,
          cliIdentificacion: datos.cliIdentificacion,
          cliPersoneria: datos.cliPersoneria,
          cliCodigoTipoDocumento: datos.cliCodigoTipoDocumento,
          cliCodigoEstadoCivil: datos.cliCodigoEstadoCivil,
          cliCodGenero: datos.cliCodGenero,
          cliCodigoCiudad: datos.cliCodigoCiudad,
          cliCodigoProvincia: datos.cliCodigoProvincia,
          codProvincia2: datos.cliCodigoProvincia && datos.cliCodigoProvincia != ''
            ? {
              value: datos.cliCodigoProvincia,
              label: typeof datos.cliProvincia === 'object' && datos.cliProvincia !== null
                ? (datos.cliProvincia.label || datos.cliProvincia.name)
                : datos.cliProvincia
            }
            : null,
          codCiudad2: datos.cliCodigoCiudad && datos.cliCodigoCiudad != ''
            ? {
              value: datos.cliCodigoCiudad,
              label: typeof datos.cliCiudad === 'object' && datos.cliCiudad !== null
                ? (datos.cliCiudad.label || datos.cliCiudad.name)
                : datos.cliCiudad
            }
            : null,
          cliFechaNacimiento: typeof datos.cliFechaNacimiento == 'string' ? datos.cliFechaNacimiento : formatearFecha(new Date(datos.cliFechaNacimiento)),
          cliRazonSocial: datos.cliRazonSocial,
        };

        console.log('datosClienteasdasd', datos.cliIdentificacion, datosCliente.cliNombres)

        dispatch(setDatosPagador(datosCliente));
        dispatch(setDatosFacturacion(datosCliente));
      } else {
        //console.log("entre a else ", transaccion);
        dispatch(setDatosPagador({}));
        dispatch(obtenerDatosClienteError());
      }
    })

    .catch((response) => {
      // console.log("error", response)
      dispatch(setDatosPagador({}));
      dispatch(obtenerDatosClienteError());
    });
};

export const FetchDescargarCotizacionRenovacion = (param) => async (dispatch) => {
  console.log("ingreso a generar");
  var url = `${urlGenerarCotizacionAutoRenovacion}`;
  if (param.accion === "descargar") {
    dispatch(generarCotizacionIsLoading());
  } else {
    dispatch(enviarCotizacionIsLoading());
  }
  httpClient.post(url, param)
    .then((data) => {
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        if (param.accion === "descargar") {
          const urlPdf = data.urlpdf;
          const accion = data.accion;
          const datosDescarga = {
            urlPdf,
            accion,
          };

          dispatch(setDatosDescarga(datosDescarga));
          dispatch(setDescargaOK(true));
        } else {
          const accion = data.accion;
          const mensaje = data.mensaje;
          const datosEnvio = {
            accion,
            mensaje,
          };
          dispatch(setDatosDescarga(datosEnvio));
          dispatch(setEnvioOK(true));
        }
      } else {
        if (param.accion === "descargar") {
          dispatch(generarCotizacionHasError());
        } else {
          dispatch(enviarCotizacionHasError());
        }

        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosDescarga(data));
        dispatch(setDescargaOK(false));
        dispatch(setEnvioOK(false));
      }
    })
    .catch((response) => {
      console.error(response);
      if (param.accion === "descargar") {
        dispatch(generarCotizacionHasError());
      } else {
        dispatch(enviarCotizacionHasError());
      }
      dispatch(setDatosDescarga({}));
      dispatch(setDescargaOK(false));
      //dispatch(ProductosCarrito(response));
    });
};



export const consultarPlacaFetch = (placa, esKilometrosPaquete, esComparador, idCarrito) => {
  return async (dispatch) => {
    console.log("placa222", urlConsultarPlaca + placa + esComparador);
    dispatch(consultarPlacaIsLoading());

    let url = `${urlConsultarPlaca}${encodeURIComponent(placa)}`;

    if (esKilometrosPaquete) {
      url += `&productoEspecial=vehiculosKilometrosPaquete`;
    }
    if (esComparador) {
      url += `&productoEspecial=comparador`;
    }
    if (idCarrito) {
      url += `&idCarrito=${encodeURIComponent(idCarrito)}`;
    }

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        //data = desencriptarTramaAES(data.Data, data.key, data.iv);
        const transaccion = data.transaccion;
        if (transaccion) {
          //Crear nodo con los datos para las validaciones de Edad
          const validacionesEdad = {
            valorMaximoEdad: data.valorMaximoEdad ? data.valorMaximoEdad : 0,
            valorMinimoEdad: data.valorMinimoEdad ? data.valorMinimoEdad : 0,
            pasoValidacionEdad: data.cumpleEdad ? data.cumpleEdad : false,
            edadActual: data.edadPersona ? data.edadPersona : 0,
            encontroConsultaStupendo: data.encontroCliente
              ? data.encontroCliente
              : false,
            mensajeValidacionEdad: data.mensajeValidacionEdad
              ? data.mensajeValidacionEdad
              : "",
          };

          const datosPersona = {
            cedula: data.cedula_propietario,
            nombre: data.nombre_propietario,
            fechaNacimiento: data.fecha_nacimiento_propietario,
            estadoCivil: data.estado_civil_propietario,
            codigoEstadoCivil: data.codigo_estado_civil_propietario,
            genero: data.genero_propietario,
            codigoGenero: data.codigo_genero_propietario,
            validacionesEdad: validacionesEdad,
          };

          const datosPersonaAsegurado = {
            // cedula: data.cedula_propietario,
            cedulaAsegurado: data.cedula_propietario,
            nombreAsegurado: data.nombre_propietario,
            fechaNacimientoAsegurado: data.fecha_nacimiento_propietario,
            estadoCivilAsegurado: data.estado_civil_propietario,
            codigoEstadoCivilAsegurado: data.codigo_estado_civil_propietario,
            generoAsegurado: data.genero_propietario,
            codigoGeneroAsegurado: data.codigo_genero_propietario,
            //    celularAsegurado: getFirstNumber(data.telefono_celular),
            validacionesEdad: validacionesEdad,
          };

          const datosPersonaContratante = {
            // cedula: data.cedula_propietario,
            cedulaContratante: data.cedula_propietario,
            nombreContratante: data.nombre_propietario,
            fechaNacimientoContratante: data.fecha_nacimiento_propietario,
            estadoCivilContratante: data.estado_civil_propietario,
            codigoEstadoCivilContratante: data.codigo_estado_civil_propietario,
            generoContratante: data.genero_propietario,
            codigoGeneroContratante: data.codigo_genero_propietario,
            //    celularContratante: getFirstNumber(data.telefono_celular),
            validacionesEdad: validacionesEdad,
          };
          dispatch(setDatosPersona(datosPersona));
          dispatch(setDatosPersonaAsegurado(datosPersonaAsegurado));
          dispatch(setDatosPersonaContratante(datosPersonaContratante));

          let arrayMarcas = [];
          let arrayMarcasSelect = []; //Agregado para caso Especial
          if (data.mostrarMarcas) {
            arrayMarcas.push({ id: "", name: "Selecciona una marca" });
            data.marcas.forEach((element) => {
              const elemento = {
                id: element.marCodigoCore,
                name: element.marNombre,
              };

              arrayMarcas.push(elemento);
            });

            //Agregado para caso especial
            data.marcas.forEach((element) => {
              const elemento = {
                value: element.marCodigoCore,
                label: element.marNombre,
              };
              arrayMarcasSelect.push(elemento);
            });
          } else {
            const elemento = {
              id: data.marCodigoCore,
              name: data.marca,
            };

            //console.log("eNTRE A LLENAR ARRAYS3");

            //console.log("NO MOSTRAR MARCAS ", arrayMarcas)

            arrayMarcas.push(elemento);
          }

          let arrayModelos = [];



          if (data.mostrarModelos) {
            arrayModelos.push({ id: "", name: "Selecciona un modelo" });
            data.modelos.forEach((element) => {
              let modelos = data.modelos;
              let arrayModelosSelect = [];

              modelos.forEach((element) => {
                const elemento = {
                  value: element.modCodigoCore,
                  label: element.modNombre,
                  modCodTipoVehiculo: element.modCodTipoVehiculo,
                  clase: element.clase,
                };
                arrayModelosSelect.push(elemento);
              });

              dispatch(setModelos(arrayModelosSelect));
            });
          } else {
            const elemento = {
              id: data.modCodigoCore,
              name: data.modelo,
              modCodTipoVehiculo: data.modCodTipoVehiculo,
              marCodigoCore: data.marCodigoCore,
              clase: data.clase,
            };

            arrayModelos.push(elemento);
          }

          let arrayTipos = [];
          if (data.mostrarTipo) {
            arrayTipos.push({ id: "", name: "Selecciona el uso" });
            data.arrayTipo.forEach((element) => {
              const elemento = {
                id: element.tipoCodigo,
                name: element.tipoDescripcion,
              };

              arrayTipos.push(elemento);
            });
          } else {
            /*const elemento={
               id:data.tipo,
               name:data.tipo
             };

             console.log("eNTRE A LLENAR ARRAYS3");
             
             console.log("NO MOSTRAR MARCAS ",arrayTipos)
           
             arrayTipos.push(elemento)*/
            arrayTipos.push({ id: "", name: "Selecciona el uso" });
            data.arrayTipo.forEach((element) => {
              const elemento = {
                id: element.tipoCodigo,
                name: element.tipoDescripcion,
              };

              arrayTipos.push(elemento);
            });
          }

          let dataConsulta = {
            arrayMarcas: arrayMarcas,
            marcaSeleccionada: arrayMarcas[0].id,
            arrayModelos: arrayModelos,
            arrayTipos: arrayTipos,
            modeloSeleccionado: arrayModelos[0].id,
            arrayMarcasSelect: arrayMarcasSelect, //Agregado por validaciones
            ...data,
          };

          /*ES Default Values*/
          //dataConsulta = cargarDatosAdicionales(dataConsulta, datosPersona);
          dispatch(setConsultaPlaca(dataConsulta));
        } else if (
          typeof data.tienePolizaVigente !== "undefined" &&
          data.tienePolizaVigente === true
        ) {
          dispatch(tienePolizaPlaca());
          dispatch(setMensajeError(data.errorDescripcion ? data.errorDescripcion : data.MensajeRestriccion));
          console.log("thisis: ", data.errorDescripcion)
          //dispatch(consultarPlacaError());
        } else {
          //console.log("entre a else ", transaccion);
          let arrayMarcas = [];
          if (data.mostrarMarcas) {
            arrayMarcas.push({ id: "", name: "Selecciona una marca" });
            data.marcas.forEach((element) => {
              const elemento = {
                id: element.marCodigoCore,
                name: element.marNombre,
              };

              arrayMarcas.push(elemento);
            });
          } else {
            const elemento = {
              id: data.marCodigoCore,
              name: data.marca,
            };

            //console.log("eNTRE A LLENAR ARRAYS3");

            //console.log("NO MOSTRAR MARCAS ", arrayMarcas)

            arrayMarcas.push(elemento);
          }

          let arrayTipos = [];
          if (data.mostrarTipo) {
            arrayTipos.push({ id: "", name: "Selecciona el uso" });
            data.arrayTipo.forEach((element) => {
              const elemento = {
                id: element.tipoCodigo,
                name: element.tipoDescripcion,
              };

              arrayTipos.push(elemento);
            });
          } else {
            const elemento = {
              id: data.tipo,
              name: data.tipo,
            };

            //console.log("eNTRE A LLENAR ARRAYS3");

            //console.log("NO MOSTRAR MARCAS ", arrayTipos)

            arrayTipos.push(elemento);
          }

          let arrayMarcasSelect = [];

          data.marcas.forEach((element) => {
            const elemento = {
              value: element.marCodigoCore,
              label: element.marNombre,
            };
            arrayMarcasSelect.push(elemento);
          });

          let dataConsulta = {
            arrayMarcas: arrayMarcas,
            marcaSeleccionada: arrayMarcas[0].id,
            arrayTipos: arrayTipos,
            arrayMarcasSelect: arrayMarcasSelect,
            ...data,
          };

          if (data.mostrarModelos && placa != 'PEND') {
            let arrayModelos = [];
            arrayModelos.push({ id: "", name: "Selecciona un modelo" });
            data.modelos.forEach((element) => {
              let modelos = data.modelos;
              let arrayModelosSelect = [];

              modelos.forEach((element) => {
                const elemento = {
                  value: element.modCodigoCore,
                  label: element.modNombre,
                  modCodTipoVehiculo: element.modCodTipoVehiculo,
                  clase: element.clase,
                };
                arrayModelosSelect.push(elemento);
              });

              dispatch(setModelos(arrayModelosSelect));
            });
          }

          //Crear nodo con los datos para las validaciones de Edad
          const validacionesEdad = {
            valorMaximoEdad: data.valorMaximoEdad ? data.valorMaximoEdad : 0,
            valorMinimoEdad: data.valorMinimoEdad ? data.valorMinimoEdad : 0,
            pasoValidacionEdad: data.cumpleEdad ? data.cumpleEdad : false,
            edadActual: data.edadPersona ? data.edadPersona : 0,
            encontroConsultaStupendo: data.encontroCliente
              ? data.encontroCliente
              : false,
            mensajeValidacionEdad: data.mensajeValidacionEdad
              ? data.mensajeValidacionEdad
              : "",
          };

          const datosPersona = {
            validacionesEdad: validacionesEdad,
          };
          dispatch(setDatosPersona(datosPersona));
          //Fin Crear nodo con los datos para las validaciones de Edad

          dispatch(setConsultaPlaca(dataConsulta));

          dispatch(consultarPlacaError());
        }
      })

      .catch(() => {
        let dataConsulta = {
          errorDescripcion:
            "Error en la consulta. Por favor verifique su placa ó reintente más tarde ",
        };

        dispatch(setConsultaPlaca(dataConsulta));
        dispatch(consultarPlacaError());
      });
  };
};

export const consultarCedulaFetch = (cedula, esAsegurado, esContratante, esInicial) => async (dispatch) => {
  //console.log("cambiar", urlConsultarCedula + cedula);

  dispatch(consultarCedulaIsLoading());
  const data = await httpClient.get(urlConsultarCedula + cedula + "&ramo=vehiculos");

  if (!data || data.errorDescripcion) {
    dispatch(consultarCedulaError());
    return;
  }

  const transaccion = data.transaccion;
  const validacionesEdad = {
    valorMaximoEdad: data.valorMaximoEdad ? data.valorMaximoEdad : 18,
    valorMinimoEdad: data.valorMinimoEdad ? data.valorMinimoEdad : 70,
    pasoValidacionEdad: data.cumpleEdad ? data.cumpleEdad : false,
    edadActual: data.edad ? data.edad : 0,
    encontroConsultaStupendo: data.encontroCliente
      ? data.encontroCliente
      : false,
    mensajeValidacionEdad: data.mensajeValidacionEdad
      ? data.mensajeValidacionEdad
      : "",
  };

  if (transaccion) {

        if (esContratante) {
          console.log("esContratante dentro de transaction ", esContratante);
          const datosPersona = {
            cedulaContratante: data.cedula,
            nombreContratante: data.nombre,
            fechaNacimientoContratante: data.fecha_nacimiento,
            estadoCivilContratante: data.estado_civil,
            codigoEstadoCivilContratante: data.codigo_estado_civil,
            generoContratante: data.genero,
            celularContratante: getFirstNumber(data.telefono_celular),
            codigoGeneroContratante: data.codigo_genero,
            validacionesEdad: validacionesEdad,
          };
          dispatch(setDatosPersonaContratante(datosPersona));

    }

        if (esAsegurado) {
          const datosPersona = {
            cedulaAsegurado: data.cedula,
            nombreAsegurado: data.nombre,
            fechaNacimientoAsegurado: data.fecha_nacimiento,
            estadoCivilAsegurado: data.estado_civil,
            codigoEstadoCivilAsegurado: data.codigo_estado_civil,
            generoAsegurado: data.genero,
            celularAsegurado: getFirstNumber(data.telefono_celular),
            codigoGeneroAsegurado: data.codigo_genero,
            validacionesEdad: validacionesEdad,
          };
          dispatch(setDatosPersonaAsegurado(datosPersona));

        } else {

      var datosPersona = {
        cedula: data.cedula,
        nombre: data.nombre,
        fechaNacimiento: data.fecha_nacimiento,
        estadoCivil: data.estado_civil,
        codigoEstadoCivil: data.codigo_estado_civil,
        genero: data.genero,
        celular: getFirstNumber(data.telefono_celular),
        codigoGenero: data.codigo_genero,
        validacionesEdad: validacionesEdad,
      };
      dispatch(setDatosPersona(datosPersona));

          if (esInicial) {

            datosPersona = {
              cedulaAsegurado: data.cedula,
              nombreAsegurado: data.nombre,
              fechaNacimientoAsegurado: data.fecha_nacimiento,
              estadoCivilAsegurado: data.estado_civil,
              codigoEstadoCivilAsegurado: data.codigo_estado_civil,
              generoAsegurado: data.genero,
              celularAsegurado: getFirstNumber(data.telefono_celular),
              codigoGeneroAsegurado: data.codigo_genero,
              //validacionesEdad: validacionesEdad,
            };


            dispatch(setDatosPersonaAsegurado(datosPersona));
            dispatch(setDatosPersonaContratante(datosPersona));
          }
        }

      } else {
        //console.log("entre a else ", transaccion);

    let generos = data.arraygeneros;
    let arrayGeneros = [];
    if (generos.length > 1)
      arrayGeneros.push({ id: "", name: "Seleccione el género" });
    generos.forEach((element) => {
      const elemento = {
        id: element.genCodigoCore,
        name: element.genDescripcion,
      };
      arrayGeneros.push(elemento);
    });

    let eciviles = data.arrayeciviles;
    let arrayECiviles = [];
    if (eciviles.length > 1)
      arrayECiviles.push({ id: "", name: "Seleccione el estado civil" });
    eciviles.forEach((element) => {
      const elemento = {
        id: element.ecivCodigoCore,
        name: element.ecivNombre,
      };
      arrayECiviles.push(elemento);
    });

    var datosPersona = {
      arrayECiviles: arrayECiviles,
      arrayGeneros: arrayGeneros,
      ...data,
    };

    // Control por separado de Asegurado y Contratante
    let errorAsegurado = false;
    let errorContratante = false;

    if (esAsegurado) {
      const datosAsegurado = {
        cedulaAsegurado: data.cedula,
        nombreAsegurado: data.nombre,
        fechaNacimientoAsegurado: data.fecha_nacimiento,
        estadoCivilAsegurado: data.estado_civil,
        codigoEstadoCivilAsegurado: data.codigo_estado_civil,
        generoAsegurado: data.genero,
        celularAsegurado: getFirstNumber(data.telefono_celular),
        codigoGeneroAsegurado: data.codigo_genero,
        validacionesEdad: validacionesEdad,
      };
      dispatch(setDatosPersonaAsegurado(datosAsegurado));

      if (!data.cedula || !data.nombre) {
        errorAsegurado = true;
      }
    }

    if (esContratante) {
      const datosContratante = {
        cedulaContratante: data.cedula,
        nombreContratante: data.nombre,
        fechaNacimientoContratante: data.fecha_nacimiento,
        estadoCivilContratante: data.estado_civil,
        codigoEstadoCivilContratante: data.codigo_estado_civil,
        generoContratante: data.genero,
        celularContratante: getFirstNumber(data.telefono_celular),
        codigoGeneroContratante: data.codigo_genero,
        validacionesEdad: validacionesEdad,
      };
      dispatch(setDatosPersonaContratante(datosContratante));

      if (!data.cedula || !data.nombre) {
        errorContratante = true;
      }
    }

    // Control de error solo si ambos, asegurado y contratante, no se encontraron
    if (!esAsegurado && !esContratante) {
      dispatch(setDatosPersona(datosPersona));
    }

    if (errorAsegurado) {
      dispatch(consultarCedulaAseguradoError());
    }

    if (errorContratante) {
      dispatch(consultarCedulaContratanteError());
    }

    if (!esAsegurado && !esContratante) {
      dispatch(consultarCedulaError());
    }
  }
};

export const listarAccesoriosFetch = () => async (dispatch) => {
  // console.log("cambiar", urlListarAccesorios);
  dispatch(listarAccesoriosIsLoading());
  await fetch(urlListarAccesorios)
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let accesorios = data.accesorios;

        dispatch(setAccesorios(accesorios));
      } else {
        // console.log("entre a else ", transaccion);
        dispatch(listarAccesoriosError());
      }
    })

    .catch(() => {
      dispatch(listarAccesoriosError());
    });
};

export const listarColoresFetch = (productoEspecial) => async (dispatch) => {
  //console.log("urlListarColores:", urlListarColores);
  dispatch(listarColoresIsLoading());
  await fetch(`${urlListarColores}${productoEspecial ? `&productoEspecial=${productoEspecial}` : ``}`)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      const transaccion = data.transaccion;
      if (transaccion) {
        let colores = data.colores;
        let limChasis = data.limitesCharChasis;
        let limAvaluo = data.limiteAvaluo;
        let limMotor = data.limitesCharMotor;
        let limAmparo = data.limiteValorAmparo;
        dispatch(setColores(colores));
        dispatch(setLimitesChasis(limChasis));
        dispatch(setLimitesAvaluo(limAvaluo));
        dispatch(setLimitesAmparo(limAmparo));

        dispatch(setLimitesMotor(limMotor));
      } else {
        //console.log("entre a else ", transaccion);
        dispatch(listarColoresError());
        dispatch(limitesError(true));
      }
    })
    .catch(() => {
      dispatch(listarColoresError());
      dispatch(limitesError(true));
    });
};

export const listarTipoCombustibleFetch = () => {
  return async (dispatch) => {
    try {
      const data = await httpClient.get(`${urlCatalogoTipoCombustible}`);
      if (data.transaccion) {
        let tipos = data.data || [];
        let arrayTipos = [];
        if (tipos.length > 0) {
          arrayTipos.push({ id: "", name: "Seleccione el tipo de combustible" });
        }
        tipos.forEach((element) => {
          arrayTipos.push({
            id: element.codCore,
            name: element.nombre
          });
        });
        dispatch(setTipoCombustible(arrayTipos));
      } else {
        dispatch(listarTipoCombustibleError());
      }
    } catch (error) {
       console.error("Error al obtener catálogo de combustible:", error);
      dispatch(listarTipoCombustibleError());
    }
  };
};



export const listarTerritoriosFetch = () => async (dispatch) => {
  //console.log("cambiarss", urlListarTerritorios);
  dispatch(listarTerritoriosIsLoading());
  await fetch(urlListarTerritorios)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let territorios = data.ciudades;

        dispatch(setTerritorios(territorios));
        dispatch(setTerritoriosDefault(data.territodioDefault));
      } else {
        //console.log("entre a else ", transaccion);
        dispatch(listarTerritoriosError());
      }
    })

    .catch((response) => {
      //console.log("error", response)
      dispatch(listarTerritoriosError());
    });
};

export const listarProvinciasComparadorFetch = (ramo, sucursal) => async (dispatch) => {
  //console.log("cambiarss", urlListarTerritorios);
  dispatch(listarTerritoriosIsLoading());
  await fetch(`${urlListarProvinciasComparador}&ramo=${ramo == 'externo' ? 'comparador' : ramo}&sucursal=${sucursal}`)
    .then((response) => response.json())
    .then((data) => {
      console.log('data.provincias', data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let territorios = data;

        dispatch(setDataTerritoriosComparador(territorios));

      } else {
        //console.log("entre a else ", transaccion);
        dispatch(listarTerritoriosError());
      }
    })

    .catch((response) => {
      //console.log("error", response)
      dispatch(listarTerritoriosError());
    });
};

export const listarProvinciasComparadorFetchRenovacion = (ramo, sucursal) => async (dispatch) => {
  //console.log("cambiarss", urlListarTerritorios);
  dispatch(listarTerritoriosIsLoading());
  await fetch(`${urlListarProvinciasComparador}&ramo=comparador&sucursal=${sucursal}`)
    .then((response) => response.json())
    .then((data) => {
      console.log('data.provincias', data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let territorios = data;

        dispatch(setDataTerritoriosComparador(territorios));

      } else {
        //console.log("entre a else ", transaccion);
        dispatch(listarTerritoriosError());
      }
    })

    .catch((response) => {
      //console.log("error", response)
      dispatch(listarTerritoriosError());
    });
};

export const listarModelosFetch = (marca, esComparador) => async (dispatch) => {
  dispatch(listarModelosIsLoading());
  await fetch(`${urlListarModelos}${marca}${esComparador ? `&filtro=&producto=comparador` : ``}`)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let modelos = data.modelos;
        let arrayModelosSelect = [];

        modelos.forEach((element) => {
          const elemento = {
            value: element.modCodigoCore,
            label: element.modNombre,
            modCodTipoVehiculo: element.modCodTipoVehiculo,
            clase: element.clase,
          };
          arrayModelosSelect.push(elemento);
        });
        dispatch(setModelos(arrayModelosSelect));
      } else {
        //console.log("entre a else ", transaccion);
        dispatch(listarModelosError());
      }
    })

    .catch((response) => {
      //console.log("error", response)
      dispatch(listarModelosError());
    });
};

export const obtenerDatosClienteFetch = (idCliente) => async (dispatch) => {
  //console.log(`cambiar url ${urlObtenerDatosCliente}${idCliente}`);
  dispatch(obtenerDatosClienteIsLoading());
  await fetch(`${urlObtenerDatosCliente}${idCliente}`)
    .then((response) => response.json())
    .then((data) => {
      console.log('datosSolicitarContrasenia', datosSolicitarContrasenia.cliEmail, data.datosCliente.cliEmail);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let datos = data.datosCliente;
        const datosCliente = {
          cliNombres: datos.cliNombre1 + " " + datos.cliNombre2,
          cliApellidos: datos.cliApellido1 + " " + datos.cliApellido2,
          cliCelular: datos.cliCelular,
          // cliEmail: datosSolicitarContrasenia.cliEmail,
          cliEmail: datos.cliEmail,
          cliTelefono: datos.cliTelefono,
          cliDireccion: datos.cliDireccion,
          cliIdentificacion: datos.cliIdentificacion,
          cliPersoneria: datos.cliPersoneria,
          cliCodigoTipoDocumento: datos.cliCodigoTipoDocumento,
          cliCodigoEstadoCivil: datos.cliCodigoEstadoCivil,
          cliCodGenero: datos.cliCodGenero,
          cliCodigoCiudad: datos.cliCodigoCiudad,
          cliCodigoProvincia: datos.cliCodigoProvincia,
          cliFechaNacimiento: typeof datos.cliFechaNacimiento == 'string' ? datos.cliFechaNacimiento : formatearFecha(new Date(datos.cliFechaNacimiento)),
        };

        dispatch(setDatosPagador(datosCliente));
        dispatch(setDatosFacturacion(datosCliente));
      } else {
        //console.log("entre a else ", transaccion);
        dispatch(setDatosPagador({}));
        dispatch(obtenerDatosClienteError());
      }
    })

    .catch((response) => {
      // console.log("error", response)
      dispatch(setDatosPagador({}));
      dispatch(obtenerDatosClienteError());
    });
};

export const obtenerDatosFetch = (cedula, tipo, personeria) => async (dispatch) => {
  dispatch(obtenerDatosClienteIsLoading());
  const data = await httpClient.get(urlConsultarCedula + cedula);

  if (!data || data.errorDescripcion) {
    var today = new Date();
    const datosCliente = {
      cliNombres: "",
      cliApellidos: "",
      cliCelular: "",
      cliEmail: "",
      cliTelefono: "",
      cliDireccion: "",
      cliIdentificacion: cedula,
      cliPersoneria: personeria ? personeria : (cedula.length === 13 ? 2 : 1),
      cliCodigoTipoDocumento: cedula.length === 13 ? infoIds.codigoRucStr : infoIds.codigoCedulaNum,
      cliCodigoEstadoCivil: "",
      cliCodGenero: "",
      cliCodigoCiudad: "",
      cliCodigoProvincia: "",
      cliFechaNacimiento: `${today.getFullYear()}/${parseInt(today.getMonth()) + 1}/1`,
    };
    if (tipo === 1) {
      dispatch(setDatosPagador(datosCliente));
    } else {
      dispatch(setDatosFacturacion(datosCliente));
    }
    dispatch(obtenerDatosClienteError());
    return;
  }

  const transaccion = data.transaccion;
  if (transaccion) {
    let datosCliente = {};
    if (cedula.length === 13) {
      datosCliente = {
        cliNombres: data.razon_social,
        cliApellidos: " ",
        cliCelular: data.celulares,
        cliEmail: data.emails,
        cliTelefono: data.telefonos,
        cliDireccion: data.direcciones,
        cliIdentificacion: data.ruc,
        cliPersoneria: personeria,
        cliCodigoTipoDocumento: infoIds.codigoRucStr,
        cliCodigoEstadoCivil: "",
        cliCodGenero: "",
        cliCodigoCiudad: "",
        cliCodigoProvincia: "",
        cliFechaNacimiento: data.fecha_inicio,
      };
    } else {
      datosCliente = {
        cliNombres: data.nombre1 + " " + data.nombre2,
        cliApellidos: data.apellido1 + " " + data.apellido2,
        cliCelular: data.celulares,
        cliEmail: data.email,
        cliTelefono: data.telefonos,
        cliDireccion: data.direcciones,
        cliIdentificacion: data.cedula,
        cliPersoneria: personeria,
        cliCodigoTipoDocumento: infoIds.codigoCedulaStr,
        cliCodigoEstadoCivil: data.codigo_estado_civil,
        cliCodGenero: data.codigo_genero,
        cliCodigoCiudad: "",
        cliCodigoProvincia: "",
        cliFechaNacimiento: data.fecha_nacimiento,
      };
    }

    if (tipo === 1) {
      dispatch(setDatosPagador(datosCliente));
    } else {
      dispatch(setDatosFacturacion(datosCliente));
    }
  } else {
    var today = new Date();

    const datosCliente = {
      cliNombres: "",
      cliApellidos: "",
      cliCelular: "",
      cliEmail: "",
      cliTelefono: "",
      cliDireccion: "",
      cliIdentificacion: cedula,
      cliPersoneria: personeria,
      cliCodigoTipoDocumento: cedula.length == 13 ? infoIds.codigoRucStr : infoIds.codigoCedulaStr,
      cliCodigoEstadoCivil: "",
      cliCodGenero: "",
      cliCodigoCiudad: "",
      cliCodigoProvincia: "",
      cliFechaNacimiento: `${today.getFullYear()}/${parseInt(today.getMonth()) + 1}/1`,
    };
    if (tipo === 1) {
      dispatch(setDatosPagador(datosCliente));
    } else {
      dispatch(setDatosFacturacion(datosCliente));
    }
    dispatch(obtenerDatosClienteError());
  }
};

const formatearFecha = (date) => {

  if (typeof date.getMonth === 'function') {
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()

    if (month < 10) {
      return (`${day}/0${month}/${year}`)
    } else {
      return (`${day}/${month}/${year}`)
    }
  } else {
    return date
  }

}

export const listarGenerosFetch = () => async (dispatch) => {
  // console.log(`cambiar url ${urlListarGeneros}`);
  dispatch(listarGenerosIsLoading());
  await fetch(`${urlListarGeneros}`)
    .then((response) => response.json())
    .then((data) => {
      //   console.log(data);

      //data = desencriptarTramaAES(data.Data, data.key, data.iv);
      const transaccion = data.transaccion;
      if (transaccion) {
        let generos = data.generos;

        let arrayGeneros = [];
        if (generos.length > 1)
          arrayGeneros.push({ id: "", name: "Seleccione el género" });
        generos.forEach((element) => {
          const elemento = {
            id: element.genCodigoCore,
            name: element.genDescripcion,
          };
          arrayGeneros.push(elemento);
        });

        dispatch(setGeneros(arrayGeneros));
      } else {
        //  console.log("entre a else ", transaccion);
        dispatch(setGeneros([]));
        dispatch(listarGenerosHasError());
      }
    })

    .catch((response) => {
      // console.log("error", response)
      dispatch(setGeneros([]));
      dispatch(listarGenerosHasError());
    });
};

export const listarECivilesFetch = () => async (dispatch) => {
  // console.log(`cambiar url ${urlListarEstadosCiviles}`);
  dispatch(listarECivilesIsLoading());
  await fetch(`${urlListarEstadosCiviles}`)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.transaccion) {
        let eciviles = data.eciviles;
        let arrayECiviles = [];
        if (eciviles.length > 1)
          arrayECiviles.push({ id: "", name: "Seleccione el estado civil" });
        eciviles.forEach((element) => {
          const elemento = {
            id: element.ecivCodigoCore,
            name: element.ecivNombre,
          };
          arrayECiviles.push(elemento);
        });
        dispatch(setEstadosCiviles(arrayECiviles));
      } else {
        dispatch(listarECivilesHasError());
        dispatch(setEstadosCiviles([]));
      }
    })

    .catch((response) => {
      dispatch(setDatosPagador([]));
      dispatch(listarECivilesHasError());
    });
};

export const listarParentescosFetch = (parametros) => async (dispatch) => {
  // console.log(`cambiar url ${urlListarEstadosCiviles}`);
  dispatch(listarECivilesIsLoading());
  await fetch(`${urlListarParentescos}&${generarParametrosUrl(parametros)}`)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {

        let parentescos = data.parentesco;
        let arrayParentescos = [];
        if (parentescos.length > 1)
          arrayParentescos.push({ id: "", name: "Seleccione el parentesco" });
        parentescos.forEach((element) => {
          const elemento = {
            id: element.parCodigo,
            name: element.parNombre,
          };
          arrayParentescos.push(elemento);
        });
        dispatch(setParentescos(arrayParentescos));
      } else {
        // dispatch(listarECivilesHasError());
        dispatch(setParentescos([]));
      }
    })

    .catch((response) => {
      dispatch(setDatosPagador([]));
      dispatch(listarECivilesHasError());
    });
};

export const listarProvinciasFetch = () => async (dispatch) => {
  await fetch(`${urlListarProvincias}`)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      if (data.transaccion) {
        let provincias = data.provincias;

        let arrayProvincias = [];
        let arrayProvinciasSelect = [];
        if (provincias.length > 1)
          arrayProvincias.push({ id: "", name: "Seleccione la provincia" });
        provincias.forEach((element) => {
          const elemento = {
            id: element.provCodigoCore,
            name: element.provNombre,
          };
          arrayProvincias.push(elemento);

          const elemento2 = {
            value: element.provCodigoCore,
            label: element.provNombre,
          };
          arrayProvinciasSelect.push(elemento2);
        });
        dispatch(setProvincias(arrayProvincias));
        dispatch(setProvincias2(arrayProvinciasSelect));
      } else {
        dispatch(listarProvinciasHasError());
        dispatch(setProvincias([]));
        dispatch(setProvincias2([]));
      }
    })

    .catch((response) => {
      //console.log("error", response)
      dispatch(setProvincias([]));
      dispatch(setProvincias2([]));
      dispatch(listarProvinciasHasError());
      dispatch(setProvincias([]));
    });
};

export const listarCiudadesFetch = (provCodigoCore) => async (dispatch) => {
  dispatch(listarCiudadesIsLoading());
  await fetch(`${urlListarCiudades}${provCodigoCore}`)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      if (data.transaccion) {
        let ciudades = data.ciudades;

        let arrayCiudades = [];
        let arrayCiudadesSelect = [];
        if (ciudades.length > 1)
          arrayCiudades.push({ id: "", name: "Seleccione la ciudad" });
        arrayCiudadesSelect.push({ id: "", name: "Seleccione la ciudad" });
        ciudades.forEach((element) => {
          const elemento = {
            id: element.ciuCodigoCore,
            name: element.ciuNombre,
            provCodigoCore: element.provCodigoCore,
          };
          arrayCiudades.push(elemento);

          const elemento2 = {
            value: element.ciuCodigoCore,
            label: element.ciuNombre,
            provCodigoCore: element.provCodigoCore,
          };
          arrayCiudadesSelect.push(elemento2);
        });

        dispatch(setCiudades(arrayCiudades));
        dispatch(setCiudades2(arrayCiudadesSelect));
      } else {
        dispatch(listarCiudadesHasError());
        dispatch(setCiudades([]));
        dispatch(setCiudades2([]));
      }
    })

    .catch((response) => {
      //console.log("error", response)
      dispatch(listarCiudadesHasError());
      dispatch(setCiudades([]));
      dispatch(setCiudades2([]));
    });
};

export const FetchGuardarDatosFacturacion = (param) => async (dispatch) => {
  var url = `${urlGuardarDatosFacturacion}`;
  dispatch(guardarDatosIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('dataPagador', data, param)
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        const urlPago = data.urlpago;
        const codigoPago = data.traCodigoPago;
        const pagopendiente = data.pagoPendiente;
        const referencia = data.referencia;
        const datosPago = {
          url: urlPago,
          codigoPago: codigoPago,
          pagopendiente: pagopendiente,
          referencia: referencia,
        };
        dispatch(setDatosPago(datosPago));
      } else {
        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosPago(data));
        dispatch(guardarDatosHasError());
      }
    })
    .catch((response) => {
      console.error(response);
      dispatch(guardarDatosHasError());
      dispatch(setDatosPago({}));
      //dispatch(ProductosCarrito(response));
    });
};

export const FetchDescargarCotizacion = (param) => async (dispatch) => {
  console.log("ingreso a generar");
  var url = `${urlGenerarCotizacion}`;
  if (param.accion === "descargar") {
    dispatch(generarCotizacionIsLoading());
  } else {
    dispatch(enviarCotizacionIsLoading());
  }
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        if (param.accion === "descargar") {
          const urlPdf = data.urlpdf;
          const accion = data.accion;
          const datosDescarga = {
            urlPdf,
            accion,
          };

          dispatch(setDatosDescarga(datosDescarga));
          dispatch(setDescargaOK(true));
        } else {
          const accion = data.accion;
          const mensaje = data.mensaje;
          const datosEnvio = {
            accion,
            mensaje,
          };
          dispatch(setDatosDescarga(datosEnvio));
          dispatch(setEnvioOK(true));
        }
      } else {
        if (param.accion === "descargar") {
          dispatch(generarCotizacionHasError());
        } else {
          dispatch(enviarCotizacionHasError());
        }

        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosDescarga(data));
        dispatch(setDescargaOK(false));
        dispatch(setEnvioOK(false));
      }
    })
    .catch((response) => {
      console.error(response);
      if (param.accion === "descargar") {
        dispatch(generarCotizacionHasError());
      } else {
        dispatch(enviarCotizacionHasError());
      }
      dispatch(setDatosDescarga({}));
      dispatch(setDescargaOK(false));
      //dispatch(ProductosCarrito(response));
    });
};
export const FetchDescargarCotizacionAuto = (param) => async (dispatch) => {
  console.log("ingreso a generar");
  var url = `${urlGenerarCotizacionAuto}`;
  if (param.accion === "descargar") {
    dispatch(generarCotizacionIsLoading());
  } else {
    dispatch(enviarCotizacionIsLoading());
  }
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        if (param.accion === "descargar") {
          const urlPdf = data.url;
          const accion = data.accion;
          const datosDescarga = {
            urlPdf,
            accion,
          };

          dispatch(setDatosDescarga(datosDescarga));
          dispatch(setDescargaOK(true));
        } else {
          const accion = data.accion;
          const mensaje = data.mensaje;
          const datosEnvio = {
            accion,
            mensaje,
          };
          dispatch(setDatosDescarga(datosEnvio));
          dispatch(setEnvioOK(true));
        }
      } else {
        if (param.accion === "descargar") {
          dispatch(generarCotizacionHasError());
        } else {
          dispatch(enviarCotizacionHasError());
        }

        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosDescarga(data));
        dispatch(setDescargaOK(false));
        dispatch(setEnvioOK(false));
      }
    })
    .catch((response) => {
      console.error(response);
      if (param.accion === "descargar") {
        dispatch(generarCotizacionHasError());
      } else {
        dispatch(enviarCotizacionHasError());
      }
      dispatch(setDatosDescarga({}));
      dispatch(setDescargaOK(false));
      //dispatch(ProductosCarrito(response));
    });
};

export const FetchDescargarCotizacionAutoRenovacion = (param) => async (dispatch) => {
  console.log("ingreso a generar");
  var url = `${urlGenerarCotizacionAutoRenovacion}`;
  if (param.accion === "descargar") {
    dispatch(generarCotizacionIsLoading());
  } else {
    dispatch(enviarCotizacionIsLoading());
  }
  httpClient.post(url, param)
    .then((data) => {
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        if (param.accion === "descargar") {
          const urlPdf = data.url;
          const accion = data.accion;
          const datosDescarga = {
            urlPdf,
            accion,
          };

          dispatch(setDatosDescarga(datosDescarga));
          dispatch(setDescargaOK(true));
        } else {
          const accion = data.accion;
          const mensaje = data.mensaje;
          const urlPdf = param.url;
          const datosEnvio = {
            accion,
            mensaje,
            urlPdf
          };
          dispatch(setDatosDescarga(datosEnvio));
          dispatch(setEnvioOK(true));
        }
      } else {
        if (param.accion === "descargar") {
          dispatch(generarCotizacionHasError());
        } else {
          dispatch(enviarCotizacionHasError());
        }

        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosDescarga(data));
        dispatch(setDescargaOK(false));
        dispatch(setEnvioOK(false));
      }
    })
    .catch((response) => {
      console.error(response);
      if (param.accion === "descargar") {
        dispatch(generarCotizacionHasError());
      } else {
        dispatch(enviarCotizacionHasError());
      }
      dispatch(setDatosDescarga({}));
      dispatch(setDescargaOK(false));
      //dispatch(ProductosCarrito(response));
    });
};

export const FetchDescargarCotizacionAbierto = (param) => async (dispatch) => {
  console.log("ingreso a generar");
  var url = `${urlGenerarCotizacionAbierto}`;
  if (param.accion === "descargar") {
    dispatch(generarCotizacionIsLoading());
  } else {
    dispatch(enviarCotizacionIsLoading());
  }
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      /*
      if (
        (data.iv !== undefined) &
        (data.Data !== undefined) &
        (data.key != undefined)
      ) {
        data = desencriptarTramaAES(data.Data, data.key, data.iv);*/

      if (data.transaccion) {
        if (param.accion === "descargar") {
          const urlPdf = data.urlpdf;
          const accion = data.accion;
          const datosDescarga = {
            urlPdf,
            accion,
          };

          dispatch(setDatosDescarga(datosDescarga));
          dispatch(setDescargaOK(true));
        } else {
          const accion = data.accion;
          const mensaje = data.mensaje;
          const datosEnvio = {
            accion,
            mensaje,
          };
          dispatch(setDatosDescarga(datosEnvio));
          dispatch(setEnvioOK(true));
        }
      } else {
        if (param.accion === "descargar") {
          dispatch(generarCotizacionHasError());
        } else {
          dispatch(enviarCotizacionHasError());
        }

        //dispatch(ProductosCarrito(ds));
        dispatch(setDatosDescarga(data));
        dispatch(setDescargaOK(false));
        dispatch(setEnvioOK(false));
      }
    })
    .catch((response) => {
      console.error(response);
      if (param.accion === "descargar") {
        dispatch(generarCotizacionHasError());
      } else {
        dispatch(enviarCotizacionHasError());
      }
      dispatch(setDatosDescarga({}));
      dispatch(setDescargaOK(false));
      //dispatch(ProductosCarrito(response));
    });
};

export const FetchPorcentajeExtras = (param, esComparador) => async (dispatch) => {
  var url = `${urlPorcentajeExtras}${param}${esComparador ? '&productoEspecial=comparador' : ''}`;
  dispatch(porcentajeExtrasIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarPorcentajeExtras());
        dispatch(setPorcentajeExtras(data.porcentajeExtras));
      } else {
        dispatch(porcentajeExtrasHasErrored());
      }
    })
    .catch((response) => {
      dispatch(porcentajeExtrasHasErrored());
    });
};

export const FetchMsg = (param) => async (dispatch) => {
  var url = `${urlObtenerMensaje}${param}`;
  dispatch(obtenerMsgIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(setMsg(data.mensaje));
      } else {
        dispatch(obtenerMsgError());
      }
    })
    .catch((response) => {
      dispatch(obtenerMsgError());
    });
};

export const FetchValidarModelo = (param, param2) => async (dispatch) => {
  var url = `${urlRestriccionModelo}${param}&modelo=${param2}`;
  dispatch(validarModeloIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(setValidarModelo(data.restringido));
      } else {
        dispatch(validarModeloError());
      }
    })
    .catch((response) => {
      dispatch(validarModeloError());
    });
};

export const FetchValidarPagoPendiente = (param) => async (dispatch) => {
  var url = `${urlValidarComprasPendientes}${param}&respuestaJson=true`;
  dispatch(validarPagoPendienteIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        let urlPago = data.urlpago ? data.urlpago : "";
        let codigoPago = data.traCodigoPago ? data.traCodigoPago : "";
        let pagopendiente = data.tienePagoPendiente
          ? data.tienePagoPendiente
          : "";
        let referencia = data.referenciaPagoPendiente
          ? data.referenciaPagoPendiente
          : "";
        let datosPago = {
          url: urlPago,
          codigoPago: codigoPago,
          pagopendiente: pagopendiente,
          referencia: referencia,
        };
        dispatch(setDatosPago(datosPago));
      } else {
        dispatch(setDatosPago({}));
        dispatch(validarPagoPendienteError());
      }
    })
    .catch((response) => {
      dispatch(validarPagoPendienteError());
    });
};

export const FetchObtenerUrlPlacetoPay = (idcarrito, ambiente, dPago) => async (
  dispatch
) => {
  var url = `${urlPlaceToPay}${idcarrito}&ambiente=${ambiente}&respuestaJson=true`;
  dispatch(obtenerUrlPagoIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        const urlPago = data.urlpago ? data.urlpago : "";
        const codigoPago = data.traCodigoPago ? data.traCodigoPago : "";
        const datosPago = {
          url: urlPago,
          codigoPago: codigoPago,
          pagopendiente: dPago.pagopendiente,
          referencia: dPago.referencia,
        };
        dispatch(setDatosPago(datosPago));
      } else {
        dispatch(obtenerUrlPagoError());
      }
    })
    .catch((response) => {
      dispatch(obtenerUrlPagoError());
    });
};

export const FetchLimpiarUrlPlacetoPay = () => async (dispatch) =>
  dispatch(limpiarUrlPago());

export const FetchSetDashboard = (param, ambiente) => async (dispatch) => {
  var url = `${urlDashboard}${param}&ambiente=${ambiente}`;
  dispatch(dashboardLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarDashboard());
        const contadorPolizas = data.contadorPolizas
          ? data.contadorPolizas
          : "0";
        const contadorCotizaciones = data.contadorCotizaciones
          ? data.contadorCotizaciones
          : "0";
        const datosDashboard = {
          contadorPolizas: contadorPolizas,
          contadorCotizaciones: contadorCotizaciones,
        };
        dispatch(setDashboard(datosDashboard));
      } else {
        dispatch(dashboardErrored());
        dispatch(msgUrlPago());
      }
    })
    .catch((response) => {
      dispatch(dashboardErrored());
    });
};

export const fetchSetPoliticasDeducibles = (esComparador) => async (dispatch) => {
  var url = `${esComparador ? urlDeduciblesRolesComparador : urlDeduciblesRoles}`;

  dispatch(deduciblesRolesisLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(deduciblesRoles(data.datos));
      } else {
        dispatch(deduciblesRoleshasError());
      }
    })
    .catch((response) => {
      dispatch(deduciblesRoleshasError());
    });
};

export const fetchGetPersonerias = () => async (dispatch, getState) => {
  const state = getState();
  let tiposPersoneria = [],
    tiposIdentificacion = [];
  const { personeria } = state.catalogosCotizacion;
  if (personeria) {
    tiposPersoneria = personeria.tiposPersoneria;
    tiposIdentificacion = personeria.tiposIdentificacion;
  }

  if (tiposPersoneria.length > 0 && tiposIdentificacion.length > 0) return;

  dispatch(
    setPersoneria({ isLoading: true, tiposPersoneria, tiposIdentificacion })
  );
  await fetch(urlPersoneria)
    .then((response) => response.json())
    .then((data) => {
      let { transaccion, tiposPersoneria, tiposIdentificacion } = data;
      if (transaccion) {
        tiposPersoneria.unshift({ id: "", name: "Seleccione una opción" });
        tiposIdentificacion.unshift({ id: "", name: "Seleccione una opción" });
        dispatch(
          setPersoneria({
            isLoading: false,
            tiposPersoneria,
            tiposIdentificacion,
          })
        );
      } else {
        dispatch(setPersoneria(""));
      }
    })
    .catch((e) => {
      console.error("Error", e);
      dispatch(setPersoneria(""));
    });
};

//Consulta identificacion - Cotizacion Accidentes Personales
export const fetchConsultarIdentificacionAP = (param) => async (dispatch) => {
  var url = `${urlConsultarIdentificacion}`;
  dispatch(consultarIdentificacionAPIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("ident es ", data);
      const transaccion = data.transaccion;
      var datosIdAP = {};
      if (transaccion) {
        datosIdAP = data.datosIdentificador;
        dispatch(setConsultarIdentificacionsAP(datosIdAP));
      } else {
        dispatch(setConsultarIdentificacionsAP(datosIdAP));
        dispatch(consultarIdentificacionAPhasError());
      }
    })
    .catch(() => {
      dispatch(consultarIdentificacionAPhasError());
    });
};



//---FORmas de pago Adicionales --------------------------------------
export const FetchObtenerFormasPago = (param) => async (dispatch) => {
  //console.log("FORMAS PAGO ", JSON.stringify(param))
  var url = `${urlObtenerFormasPago}`;
  dispatch(obtenerFormasPagoIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("FORMAS PAGO - OBTENIDOS ", data);
      if (data.transaccion) {
        const { metodosPago } = data;
        const datosAdicionales = {
          idPoliza: data.idPoliza,
          rolUser: data.rolUser
        }
        dispatch(setObtenerFormasPago(metodosPago));
        dispatch(setDatosAdicionales(datosAdicionales));
      } else {
        dispatch(obtenerFormasPagoHasError());
        dispatch(setDatosAdicionales(null));
        dispatch(setObtenerFormasPago(null));
      }
    })
    .catch((response) => {
      //console.log(response)
      dispatch(obtenerFormasPagoHasError());
      dispatch(setDatosAdicionales(null));
      dispatch(setObtenerFormasPago(null));
    });
};

//---FORmas de pago Adicionales --------------------------------------
export const FetchObtenerFormasPagoRenovaciones = (param) => async (dispatch) => {
  dispatch(obtenerFormasPagoIsLoading());
  try {
    const data = await httpClient.post(urlObtenerFormasPagoRenovaciones, param);
    console.log("FORMAS PAGO - OBTENIDOS ", data);
    if (data.transaccion) {
      const { metodosPago } = data;
      const datosAdicionales = {
        idPoliza: data.idPoliza,
        rolUser: data.rolUser
      };
      dispatch(setObtenerFormasPago(metodosPago));
      dispatch(setDatosAdicionales(datosAdicionales));
    } else {
      dispatch(obtenerFormasPagoHasError());
      dispatch(setDatosAdicionales(null));
      dispatch(setObtenerFormasPago(null));
    }
  } catch (error) {
    console.error(error);
    dispatch(obtenerFormasPagoHasError());
    dispatch(setDatosAdicionales(null));
    dispatch(setObtenerFormasPago(null));
  }
};
export const FetchDatosDebitoAutomatico = (param) => async (dispatch) => {
  //console.log("DEBITO ", JSON.stringify(param))
  //var url = `${urlObtenerDatosDebitoAutomatico}`;
  const url = `${urlObtenerDatosDebitoAutomatico}`; // site that doesn’t send Access-Control-*
  dispatch(obtenerDatosDebitoAutomaticoIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        //
        let bancos = data.bancos;
        let arrayBancos = [];
        if (bancos.length > 1)
          bancos.forEach((elementB) => {
            const elementoB = {
              value: elementB.id,
              label: elementB.nombre,
              mesesC: elementB.mesesMaximoDiferidoCuentas,
              mesesT: elementB.mesesMaximoDiferidoTarjetas,
            };
            arrayBancos.push(elementoB);
          });
        //
        let planesPago = data.planesPago;
        let arrayplanesPago = [];
        if (planesPago.length > 1)
          planesPago.forEach((elementP) => {
            const elementoP = {
              value: elementP.id,
              label: elementP.nombre,
              cuotas: elementP.numeroCuotas,
            };
            arrayplanesPago.push(elementoP);
          });
        //
        let tiposConductos = data.tiposConductos;
        let arraytiposConductos = [];
        if (tiposConductos.length > 1)
          arraytiposConductos.push({
            id: "",
            name: "Seleccione el Tipo de Conducto",
          });
        tiposConductos.forEach((elementT) => {
          const elementoT = {
            id: elementT.codigo,
            name: elementT.nombre,
            codigoCore: elementT.codigoCore,
          };
          arraytiposConductos.push(elementoT);
        });
        const datosDebito = {
          bancos: arrayBancos,
          planesPago: arrayplanesPago,
          tiposConductos: arraytiposConductos,
          valorCuotaMinimaCuenta: data.valorCuotaMinimaCuentas,
          valorCuotaMinimaTarjeta: data.valorCuotaMinimaTC,
        };
        //console.log('DEBITO - OBTENIDOS ', datosDebito)
        dispatch(setObtenerDatosDebitoAutomatico(datosDebito));
      } else {
        dispatch(obtenerDatosDebitoAutomaticoHasError());
      }
    })
    .catch((response) => {
      //console.log(response)
      dispatch(obtenerDatosDebitoAutomaticoHasError());
    });
};
export const FetchObtenerConductos = (param) => async (dispatch) => {
  //console.log("LISTADO CONDUCTOS ", JSON.stringify(param))
  var url = `${urlObtenerConductos}`;
  dispatch(obtenerConductosIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log('LISTADO CONDUCTOS - OBTENIDOS ', data)
      if (data.transaccion) {
        if (data.conductos !== undefined) {
          //console.log("asfsafsa", data.conductos)
          dispatch(setObtenerConductos(data.conductos));
        }
      } else {
        dispatch(obtenerConductosHasError());
      }
    })
    .catch((response) => {
      //console.log(response)
      dispatch(obtenerConductosHasError());
    });
};
export const FetchGuardarDatosConducto = (param) => async (dispatch) => {
  //console.log("GUARDAR CONDUCTO ", JSON.stringify(param))
  var url = `${urlGuardarConducto}`;
  dispatch(guardarConductoIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log('-------', data)
      if (data.transaccion) {
        const idConducto = data.idConducto;
        dispatch(setGuardarConducto(idConducto));
      } else {
        dispatch(guardarConductoHasError());
      }
    })
    .catch((response) => {
      //console.log(response)
      dispatch(guardarConductoHasError());
    });
};
export const FetchGuardarFormaPago = (param) => async (dispatch) => {
  var url = `${urlGuardarFormasPago}`;
  dispatch(guardarFormaPagoIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error HTTP " + response.status);
      }
      return response.json();
    })
    .then((data) => {
      //console.log('-------', data)
      if (data.transaccion) {
        dispatch(setGuardarFormaPago(data));
      } else {
        dispatch(guardarFormaPagoHasError(data));
      }
    })
    .catch((response) => {
      //console.log(response)
      dispatch(guardarFormaPagoHasError({ alerta: "Ocurrió un error en el servicio al guardar su forma de pago. Por favor, inténtelo más tarde." }));
    });
};

export const FetchGuardarFormaPagoRenovaciones = (param) => async (dispatch) => {
  //console.log("GUARDAR FORMA PAGO ", JSON.stringify(param))
  var url = `${urlGuardarFormasPagoRenovaciones}`;
  dispatch(guardarFormaPagoIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error HTTP " + response.status);
      }
      return response.json();
    })
    .then(async (data) => {
      //console.log('-------', data)
      if (data.transaccion) {


        if (data.requiereIntegracion) {
          await subirSftp(param.idCarrito)
        }

     
        dispatch(setGuardarFormaPago(data));
      } else {
        dispatch(guardarFormaPagoHasError(data));
      }
    })
    .catch((response) => {
      //console.log(response)
      dispatch(guardarFormaPagoHasError({ alerta: "Ocurrió un error en el servicio al guardar su forma de pago. Por favor, inténtelo más tarde." }));
    });
};

// Fin Formas de pago adicionales--------------------------------------------------------------------------------

//COTIZACION HOGAR ----------------------------------------------------------------------

export const listarProvinciasHogarFetch = (ramo) => async (dispatch) => {
  dispatch(listarProvinciasHogarloading());
  await fetch(`${urlListarProvincias}&ramo=${ramo}`)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      if (data.transaccion) {
        let provincias = data.provincias;

        let arrayProvincias = [];
        let arrayProvinciasSelect = [];
        if (provincias.length > 1)
          arrayProvincias.push({ id: "", name: "Seleccione la provincia" });
        provincias.forEach((element) => {
          const elemento = {
            id: element.provCodigoCore,
            name: element.provNombre,
          };
          arrayProvincias.push(elemento);

          const elemento2 = {
            value: element.provCodigoCore,
            label: element.provNombre,
          };
          arrayProvinciasSelect.push(elemento2);
        });
        const listaProvincias = {
          provincias1: arrayProvincias,
          provincias2: arrayProvinciasSelect,
        };
        dispatch(setProvinciasHogar(listaProvincias));
      } else {
        dispatch(listarProvinciasHogarError());
        dispatch(setProvinciasHogar([]));
      }
    })
    .catch((response) => {
      dispatch(setProvinciasHogar([]));
      dispatch(listarProvinciasHogarError());
    });
};

export const listarRelatividadesHogarFetch = (param) => async (dispatch) => {
  var url = `${urlListarRelatividades}`;
  dispatch(listarRelatividadesHogarloading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setRelatividadesHogar(data.setRelatividadesHogar));
      } else {
        dispatch(listarRelatividadesHogarError());
      }
    })
    .catch(() => {
      dispatch(listarRelatividadesHogarError());
    });
};

//FIN COTIZACION HOGAR ------------------------------------------------------------------

//FACTURACION -------------------
//Obtener datos
export const recuperarDatosFacturacionFetch = (param) => async (dispatch) => {
  var url = `${urlRecuperarDatosFacturacionC}`;
  dispatch(recuperarDatosFacturacionIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      let respuesta = {};
      if (data.transaccion) {
        respuesta = data;
        dispatch(setRecuperarDatosFacturacion(respuesta));
      } else {
        dispatch(setRecuperarDatosFacturacion(respuesta));
        dispatch(recuperarDatosFacturacionhasError());
      }
    })
    .catch(() => {
      dispatch(recuperarDatosFacturacionhasError());
    });
};

export const guardarFacturacionFetch = (param) => async (dispatch) => {
  console.log("ParamGuardarDatosFacturacion", param);
  var url = `${urlGuardarDatosFacturacionC}`;

  dispatch(guardarDatosFacturacionIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      let respuesta = {};
      if (data.transaccion) {
        respuesta = data;
        dispatch(setDatosFacturacionC(respuesta));
      } else {
        respuesta = data;
        dispatch(setDatosFacturacionC(respuesta));
        dispatch(guardarDatosFacturacionhasError());
      }
    })
    .catch(() => {
      dispatch(guardarDatosFacturacionhasError());
    });
};
//FIN FACTURACION -------------

export const obtenerTipoCombustiblePorMarcaModeloFetch = (marcaCodigo, modeloCodigo) => {
  return async (dispatch) => {
    try {
      const url = `${urlTipoCombustiblePorMarcaModelo}&marcaCodigoCore=${marcaCodigo}&modeloCodigoCore=${modeloCodigo}`;
      const data = await httpClient.get(url);
      if (data && data.transaccion) {
        return data;
      }
      return null;
    } catch (error) {
      console.error("Error al obtener tipo de combustible por marca/modelo:", error);
      return null;
    }
  };
};

